module.exports = __webpack_public_path__ + "static/media/heroimage_igib-012.e51d9f47.jpg";